import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';

import { Breadcrumb, type Path } from './Breadcrumb';

import styles from './PageTitle.module.scss';

interface Props {
    title: string;
    subtitle?: ReactNode;
    className?: string;
    paths?: Path[];
}

function PageTitle({ title, subtitle, className, children, paths }: PropsWithChildren<Props>) {
    return (
        <div className={classNames(styles.container, className)}>
            {paths && <Breadcrumb paths={paths} />}
            <h1 className={styles.title}>{title}</h1>
            {children}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
    );
}

export default PageTitle;
